/**
 * Safely sets a value in sessionStorage with error handling.
 * @param key - Storage key
 * @param value - String value to store
 * @internal
 */
export const setSessionStorage = (key: string, value: string) => {
  try {
    sessionStorage.setItem(key, value)
  } catch {
    // Ignore storage failures (private mode, quota exceeded, disabled storage).
  }
}

/**
 * Safely retrieves a value from sessionStorage with error handling.
 * @param key - Storage key
 * @returns Stored value or null if error/not found
 */
export const getSessionStorage = (key: string) => {
  try {
    return sessionStorage.getItem(key)
  } catch {
    return null
  }
}

/**
 * Retrieves a boolean value from sessionStorage.
 * @param key - Storage key
 * @returns Boolean value (defaults to false if not found or not "true")
 */
export const getBooleanSessionStorage = (key: string) => {
  const value = getSessionStorage(key)
  return value ? value === 'true' : false
}
